import * as React from "react"
import { Text, Button, ButtonProps } from "@chakra-ui/react"
import { AiFillFacebook } from "react-icons/ai"

type AdditionProps = {
  onlyIcon?: boolean
}

export const FacebookButton: React.FC<ButtonProps & AdditionProps> = React.memo(
  ({ onlyIcon, ...props }) => {
    return (
      <Button
        background="#3b5998"
        color="white"
        width="130px"
        marginTop="1rem"
        _active={{}}
        _hover={{}}
        _focus={{}}
        {...props}
      >
        <AiFillFacebook size="16" />
        {!onlyIcon && <Text marginLeft="0.5rem">Facebook</Text>}
      </Button>
    )
  }
)
